module.exports = __webpack_public_path__ + "images/category_lp/earphone/store_images/3_93dec05933f35b4d5adff5374d488ba8.png";